import type { ReactNode } from 'react';

/**
 * Lo que no se puede contestar sin servidor.
 *
 * La regla que sostiene el modo sin conexión es una sola: **no inventar**. Se
 * muestra lo que ya está descargado en el teléfono y se encola lo que se carga.
 * Todo lo demás —invitar a alguien, mirar el estado del plan, liquidar un mes,
 * exportar— necesita información de ahora, y de ahora sólo sabe el servidor.
 *
 * Un importe viejo presentado como actual es peor que una pantalla que dice por
 * qué no puede mostrarlo. Peor todavía sería dejar apretar «Liquidar» y que
 * parezca que pasó algo.
 */
export function NecesitaConexion({
  que,
  children,
  testId = 'necesita-conexion',
}: {
  /** Qué es lo que necesita señal, dicho en una frase. */
  que?: string;
  /** Detalle opcional: qué SÍ se puede hacer mientras tanto. */
  children?: ReactNode;
  testId?: string;
}) {
  return (
    <div
      className="superficie-suave flex flex-col gap-2 px-4 py-6 text-center"
      role="status"
      data-testid={testId}
    >
      <p className="text-sm font-medium">Esta función necesita conexión</p>
      {que && <p className="text-sm text-[var(--tinta-suave)]">{que}</p>}
      {children}
    </div>
  );
}
